package ir.alirezaivaz.finglish.ui.theme

import androidx.compose.ui.unit.dp

object Dimens {
    val zero = 0.dp
    val extraSmall = 4.dp
    val small = 8.dp
    val medium = 12.dp
    val semiLarge = 14.dp
    val large = 16.dp
    val extraLarge = 24.dp
}
